import React, { Component } from "react";
import { I18n } from "react-redux-i18n";
import { DefaultInput } from "@alboompro/boom-components/data-entry/input/";
import Select from "@alboompro/boom-components/data-entry/select/";
import BoomCheckbox from "@alboompro/boom-components/data-entry/checkbox/";
import Icon from "@alboompro/boom-components/general/icon";
import styled from "styled-components";
import { createKey } from "shared/utils";

import {
  sortableContainer,
  sortableElement,
  sortableHandle,
  arrayMove
} from "react-sortable-hoc";

const SocialIconOptions = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const AddNewIconButton = styled.button`
  display: flex;
  flex: 1;
  padding: 8px 0;
  justify-content: center;
  color: #3a3a3a;
  font-size: 12px;
  background-color: transparent;
  border: 1px dashed #b8b8b8;
  cursor: pointer;

  &:focus {
    outline: none;
  }
`;

const IconsList = styled.div``;

const DragComponent = styled.div`
  position: relative;
  z-index: 1;
`;

const DragIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 14px;
  height: 100%;
  cursor: pointer;
  cursor: grab;
`;

const IconConfigsContainer = styled.div`
  background-color: #fff;
  margin-bottom: 10px;
  z-index: 10000;
`;

const IconConfigsTitle = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  padding: 7px 10px 7px 20px;
  border-radius: 3px;
  border: 1px solid ${props => (props.open ? "#44ADF8" : "#ebebeb")};
  background-color: ${props => (props.open ? "#44ADF8" : "#fff")};

  &:hover {
    cursor: pointer;
  }

  > img {
    width: 16px;
    height: 16px;
    margin-right: 5px;
  }

  > div {
    font-size: 12px;
    color: ${props => (props.open ? "#fff" : "#1e1e1e")};
    flex: 1;

    &:nth-child(1) {
      background-color: ${props => (props.open ? "#44ADF8" : "#c9c9c9")};
    }
  }
`;

const DeleteIcon = styled.span`
  cursor: pointer;
`;

const IconsConfigsContent = styled.div`
  height: ${prop => (prop.open ? "auto" : "0px")};
  overflow: hidden;

  > div {
    border: 1px solid #ebebeb;
    border-radius: 3px;
    border-top: none;
    padding: 15px 10px 10px;
  }

  input{
    border: 1px solid #ebebeb;
    border-radius: 3px;

    &:focus {
      box-shadow: rgb(80 175 244) 0px 0px 2px 1px;
    }
  }

  .selectInput {
    margin-bottom: 10px;
    > span {
      font-size: 12px;
      line-height: normal;
      margin-bottom: 3px;
    }
  }

  .urlInput {
    padding-bottom: 0;
  }
`;

const IconItem = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  font-weight: 400;

  > img {
    margin-right: 5px;
    width: 12px;
    height: 12px;
  }
`;

const SortableContainer = sortableContainer(({ children }) => {
  return <div>{children}</div>;
});

const DragHandle = sortableHandle(() => (
  <DragIcon>
    <Icon
      kind="bold"
      group="interface-essential"
      category="menu"
      file="navigation-menu-vertical.svg"
      size="14"
      color="#fff"
    />
  </DragIcon>
));

const SortableItem = sortableElement(({ children }) => (
  <DragComponent>{children}</DragComponent>
));

class SocialIconSelect extends Component {
  constructor(props) {
    super();
    this.state = {
      iconsList: [],
      iconsOptions: [],
      toggleOpen: null
    };
  }

  componentDidMount() {
    const { currentValue } = this.props;

    this.setState({
      iconsList: currentValue.map(item => ({ ...item, id: createKey() })),
      iconsOptions: this.listOptions()
    });
  }

  listOptions = () => {
    const { options } = this.props;
    const reduceOptions = options.reduce((acc, item) => {
      acc.push({
        label: (
          <IconItem>
            <img src={item.boomIcon} alt={item.name} />
            {item.name}
          </IconItem>
        ),
        value: item.name
      });
      return acc;
    }, []);

    return reduceOptions;
  };

  updateSelectItem = (e, ref) => {
    const { options } = this.props;
    const { iconsList } = this.state;
    // eslint-disable-next-line prefer-const
    let newIconsList = iconsList;
    const iconFilter = options.find(item => item.name === e.value);

    newIconsList[ref].color = iconFilter.color;
    newIconsList[ref].icon = iconFilter.icon;
    newIconsList[ref].name = iconFilter.name;
    newIconsList[ref].boomIcon = iconFilter.boomIcon;

    this.setState(
      {
        iconsList: newIconsList
      },
      this.updateArray(newIconsList)
    );
  };

  updateInputValue = (e, ref) => {
    const { iconsList } = this.state;
    // eslint-disable-next-line prefer-const
    let newIconsList = iconsList;
    newIconsList[ref].url = e.target.value;

    this.setState(
      {
        iconsList: newIconsList
      },
      this.updateArray(newIconsList)
    );
  };

  updateTargetValue = ref => {
    const { iconsList } = this.state;
    // eslint-disable-next-line prefer-const
    let newIconsList = iconsList;
    newIconsList[ref].target = !newIconsList[ref].target;

    this.setState(
      {
        iconsList: newIconsList
      },
      this.updateArray(newIconsList)
    );
  };

  updateArray = value => {
    const { name, updaterFn } = this.props;
    // const { iconsList } = this.state;
    updaterFn({ prop: name, value });
  };

  addNewIcon = () => {
    const { options } = this.props;
    const { iconsList } = this.state;
    // eslint-disable-next-line prefer-const
    let newIconsList = iconsList;
    const iconFilter = options.find(item => item.name === "Facebook");

    newIconsList.push({
      ...iconFilter,
      url: "https://",
      target: true,
      id: createKey()
    });

    this.setState(
      {
        iconsList: newIconsList
      },
      this.updateArray(newIconsList)
    );
  };

  deleteIcon = ref => {
    const { iconsList } = this.state;
    // eslint-disable-next-line prefer-const
    let newIconsList = iconsList;
    newIconsList.splice(ref, 1);
    this.setState(
      {
        iconsList: newIconsList
      },
      this.updateArray(newIconsList)
    );
  };

  onSortEnd = ({ oldIndex, newIndex }) => {
    this.setState(({ iconsList }) => ({
      iconsList: arrayMove(iconsList, oldIndex, newIndex)
    }));
    // eslint-disable-next-line react/destructuring-assignment
    this.updateArray(this.state.iconsList);
  };

  collapseToogle = ref => {
    const { toggleOpen } = this.state;
    let setRef;

    if (toggleOpen === ref) {
      setRef = null;
    } else {
      setRef = ref;
    }

    this.setState({
      toggleOpen: setRef
    });
  };

  render() {
    const { locale, targetLabel } = this.props;
    const { iconsList, iconsOptions, toggleOpen } = this.state;

    return (
      <SocialIconOptions>
        <IconsList>
          <SortableContainer
            onSortEnd={this.onSortEnd}
            useDragHandle
            lockAxis="y"
          >
            {iconsList.map((item, index) => (
              <SortableItem index={index} key={`${index + 1}`}>
                <IconConfigsContainer>
                  <IconConfigsTitle
                    open={toggleOpen === item.id}
                    onClick={() => this.collapseToogle(item.id)}
                  >
                    <DragHandle />
                    <img src={item.boomIcon} alt={item.name} />
                    <div>{item.name}</div>
                    {toggleOpen !== item.id && (
                      <DeleteIcon onClick={() => this.deleteIcon(index)}>
                        <Icon
                          kind="regular"
                          group="interface-essential"
                          category="delete"
                          file="bin-1.svg"
                          size="14"
                          color="#4F4F4F"
                        />
                      </DeleteIcon>
                    )}
                  </IconConfigsTitle>
                  <IconsConfigsContent open={toggleOpen === item.id}>
                    <div>
                      <Select
                        label={I18n.t("editPanel.socialIconSelect.labelSelect")}
                        value={item.name}
                        placeholder="placeholder"
                        options={iconsOptions}
                        onChange={e => this.updateSelectItem(e, index)}
                        dropdownStyle={{ maxHeight: 250, li: { fontSize: 12 } }}
                        className="selectInput"
                        selectStyle={{
                          padding: "8px 10px",
                          fontSize: 12,
                          border: "solid 1px #ebebeb",
                          borderRadius: "3px"
                        }}
                      />
                      <DefaultInput
                        name={`icon-${index}`}
                        label={I18n.t("editPanel.socialIconSelect.labelUrl")}
                        className="urlInput"
                        inputStyle={{ fontSize: "12px", padding: "8px 10px" }}
                        labelStyle={{
                          fontSize: "12px",
                          lineHeight: "normal",
                          marginBottom: "3px"
                        }}
                        value={item.url}
                        onChange={e => this.updateInputValue(e, index)}
                      />
                      <BoomCheckbox
                        onChange={() => this.updateTargetValue(index)}
                        label={targetLabel[locale]}
                        checked={item.target}
                        labelStyle={{ fontSize: 10 }}
                      />
                    </div>
                  </IconsConfigsContent>
                </IconConfigsContainer>
              </SortableItem>
            ))}
          </SortableContainer>
        </IconsList>
        <AddNewIconButton onClick={this.addNewIcon}>
          {I18n.t("editPanel.socialIconSelect.addSocialIcon")}
        </AddNewIconButton>
      </SocialIconOptions>
    );
  }
}

export default SocialIconSelect;
